module.exports = __webpack_public_path__ + "img/auth-santa-left-top.bc75aea6.png";